export const DELAY_BETWEEN_EVENTS = 5000;
